import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { smartLoaderService } from '../../services/domain/smartLoaderService';
import laptopInfo from '../../styles/default/placeholders/laptop_info_icon.png';
import { ROUTES } from '../../const';
import routerHistory from '../../routerHistory';

class ErrorPage extends React.Component {
  static propTypes = {
    description: PropTypes.string,
    errorCode: PropTypes.string,
    location: PropTypes.object,
    enableHomeView: PropTypes.bool
  };

  componentDidMount() {
    smartLoaderService.close();
  }

  render() {
    const { description, errorCode } = this.props;

    return (
      <div className="error-page-container">
        <img alt="error-page" src={laptopInfo} />
        <h1>{I18n.t('errorPage.title')}</h1>
        {description && <span>{I18n.t(description)}</span>}
        <br />
        {errorCode && (
          <div className="error-container">
            <span>{I18n.t('errorPage.errorCode')} </span>
            <span className="error-code"> {errorCode}</span>
          </div>
        )}

        {this.renderBackButton()}
      </div>
    );
  }

  renderBackButton = () => {
    const { enableHomeView } = this.props;

    if (enableHomeView) {
      return (
        <Link to={ROUTES.ROOT} onlyActiveOnIndex={true}>
          <button className="error-button">{I18n.t('errorPage.buttonLabel')}</button>
        </Link>
      );
    } else {
      return (
        <button className="error-button" onClick={this.goBack}>
          {I18n.t('errorPage.buttonLabel')}
        </button>
      );
    }
  };

  goBack = () => {
    routerHistory.go(-2);
  };
}

function mapStateToProps(state) {
  return {
    description: state.error.description,
    errorCode: state.error.code,
    enableHomeView: state.account.configuration.enableHomeView
  };
}

export default connect(mapStateToProps)(ErrorPage);
